import { useEffect, useRef } from "react";
import { DivAgegate, InputAgegate } from "theme/theme";

interface IProps {
  setValue?: (name: string, value: string) => void;
  setState?: (value: any) => void;
  defaultValue?: {
    day: number | string;
    month: number | string;
    year: number | string;
  }
}

function AgegateInput({ setValue, setState, defaultValue }: IProps) {

  const day = useRef<HTMLInputElement>(null);
  const month = useRef<HTMLInputElement>(null);
  const year = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (defaultValue) {
      const birthdayDate = new Date(+year.current?.value, +month.current?.value - 1, +day.current?.value)
      setState(birthdayDate)
      setValue("birthday", `${day.current?.value}/${month.current?.value}/${year.current?.value}`)
    }
  }, [defaultValue])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'day') {
      if (value.trim() === '') {
        day.current.value = ''
      } else if (value.length === 2) {
        if (+value > 31) {
          day.current.value = '31';
        } else {
          month?.current?.focus();
        }
      }
    } else if (name === 'month') {
      if (value.trim() === '') {
        month.current.value = ''
      } else if (value.length === 2) {
        if (+value > 12) {
          month.current.value = '12';
        } else {
          year?.current?.focus();
        }
      }
    } else if (name === 'year') {
      if (value.trim() === '') {
        year.current.value = ''
      } else if (value.trim().length === 4) {
        if (+value < 1900) {
          year.current.value = '1900';
        }
      }
    }
    const birthdayDate = new Date(+year.current?.value, +month.current?.value - 1, +day.current?.value)
    setState(birthdayDate)
    setValue("birthday", `${day.current?.value}/${month.current?.value}/${year.current?.value}`)
  }

  return (
    <DivAgegate className="h-16 p-4 w-full uppercase items-center justify-center gap-2 saira flex">
      <div className="flex-grow flex justify-end items-center cursor-pointer" onClick={() => {
        day?.current?.focus()
        gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'AGEGATE - Ingresar fecha de nacimiento', value: '10' })
      }}>
        <InputAgegate
          type="text"
          name="day"
          ref={day}
          className="w-8 flex items-center justify-center text-center font-bold"
          placeholder="DD"
          maxLength={2}
          pattern="\d*"
          defaultValue={defaultValue?.day}
          onChange={handleChange}
        />
      </div>
      <span>/</span>
      <InputAgegate
        type="text"
        name="month"
        ref={month}
        className="w-10 flex items-center justify-center text-center cursor-text font-bold"
        placeholder="MM"
        maxLength={2}
        pattern="\d*"
        onChange={handleChange}
        defaultValue={defaultValue?.month}
      />
      <span>/</span>
      <div className="flex-grow flex justify-start items-center cursor-pointer" onClick={() => {
        year?.current?.focus()
        gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'AGEGATE - Ingresar fecha de nacimiento', value: '10' })
      }}>
        <InputAgegate
          type="text"
          name="year"
          ref={year}
          className="w-12 flex items-center justify-center text-center font-bold"
          placeholder="YYYY"
          maxLength={4}
          pattern="\d*"
          defaultValue={defaultValue?.year}
          onChange={handleChange}
        />
      </div>
    </DivAgegate>
  )

}

export default AgegateInput;
